import { Wave } from 'src/types/Wave';
import { ITravellyzeState } from './state';
import { Continents } from '@/types/Continents';
import { RootState } from '../rootState';

export function settings(state: ITravellyzeState) {
  return state.settings;
}

export function currentUser(state: ITravellyzeState) {
  return state.user;
}
export function defaultWave(state: ITravellyzeState, getters) {
  if (state.user.years.length == 0) {
    return state.datasets[0];
  }
  // this is needed to keep the state immutable
  const waves = Object.assign([], state.user.years);
  return waves.sort((a, b) => {
    return b - a;
  })[0];
}

export function freeUser(state: ITravellyzeState) {
  return state.user.role == 'FREE';
}
export function isAdmin(state: ITravellyzeState) {
  return state.user.role === 'ADMIN';
}

export function reportList(state: ITravellyzeState) {
  return state.reportList;
}
export function menuMain(state: ITravellyzeState) {
  return state.menuMain;
}
export function adminMenuMain(state: ITravellyzeState) {
  return [...state.menuMain, state.menuMainAdminItem];
}

export function highlightsList(state: ITravellyzeState) {
  return state.settings.highlights;
}

export function insights(state: ITravellyzeState) {
  return {
    origin_insights: state.origin_insights,
    archetypes_insights: state.archetypes_insights
  };
}

export function menuReport(
  state: ITravellyzeState,
  getters,
  rootState,
  rootGetters
) {
  // User data
  let report = rootGetters['questions/currentReport'];

  if (report.type == 'BAR') return state.menuReportBar;
  if (report.type == 'BRAND_REPORT') return state.menuReportBar;
  if (report.type == 'RAR') return state.menuReportBar;
  if (report.type == 'CSS') return state.menuReportCSS;
  if (report.type == 'COP') return state.menuReportCOP;
  if (report.type == 'SUR') return state.menuReportSUR;
}

export function destinations2024A(state: ITravellyzeState) {
  let destinations = Object.assign([], state.destinationsIDs2024A);

  // Sort destinations
  function compare(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  return destinations.sort(compare);
}

export function destinations2023B(state: ITravellyzeState) {
  let destinations = Object.assign([], state.destinationsIDs2023B);

  // Sort destinations
  function compare(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  return destinations.sort(compare);
}
export function destinations2022B(state: ITravellyzeState) {
  let destinations = Object.assign([], state.destinationsIDs2022B);

  // Sort destinations
  function compare(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  return destinations.sort(compare);
}

export function destinations2022A(state: ITravellyzeState) {
  let destinations = Object.assign([], state.destinationsIDs2022A);

  // Sort destinations
  function compare(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  return destinations.sort(compare);
}

export function destinations2021(state: ITravellyzeState) {
  let destinations = Object.assign([], state.destinationsIDs2021);

  // Sort destinations
  function compare(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  return destinations.sort(compare);
}

export function destinations2020(state: ITravellyzeState) {
  let destinations = Object.assign([], state.destinationsIDs2021);

  // Sort destinations
  function compare(a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  }

  return destinations.sort(compare);
}

export function destinationsSelection(
  state: ITravellyzeState,
  getters,
  rootState: RootState
) {
  // User data
  let profile = rootState.questions.lastSearch;

  // Get all options depending on year
  let destinations = getters.destinations2023B;
  if (profile.year == 2021) destinations = getters.destinations2021;
  if (profile.year == 202201) destinations = getters.destinations2022A;
  if (profile.year == 202202) destinations = getters.destinations2022B;
  if (profile.year == 202302) destinations = getters.destinations2023B;

  // Filter options depending on user settings
  //   if (user.destinations)
  //     destinations.forEach(function (destination) {
  //       user.destinations.forEach(function (key) {
  //         if (user.destinations[key] == destination.label) {
  //           res.push(key);
  //         }
  //         if (user.destinations[key] == destination.value) {
  //           res.push(destination.value);
  //         }
  //       });
  //     });
  //   else res = destinations;

  return destinations;
}

export function destinationsGrouped(
  state,
  getters,
  rootState,
  rootGetters
): DestinationGroup {
  let allDestis: Destination[] = Object.assign(
    {},
    getters.destinationsPerWave(202401)
  );
  let res: Record<Continents, Destination[]> = {
    Europe: [],
    Africa: [],
    'Asia & Oceania': [],
    'Middle East': [],
    America: [],
    'Other destinations': []
  };

  // Group
  Object.keys(allDestis).forEach(function (desti) {
    let continent = allDestis[desti].continent;

    res[continent].push(allDestis[desti]);
  });
  return res;
}

export function destinationsReport(
  state: ITravellyzeState,
  getters,
  rootState,
  rootGetters
) {
  let allDestis = Object.assign({}, getters.destinations2022B);
  let res = {
    Europe: [],
    Africa: [],
    'Asia & Oceania': [],
    'Middle East': [],
    America: [],
    'Other destinations': []
  };

  // Group
  Object.keys(allDestis).forEach(function (desti) {
    let continent = allDestis[desti].continent;

    res[continent].push(allDestis[desti]);
  });
  return res;
}

// Get market selection
export function marketsSelection(
  state: ITravellyzeState,
  getters,
  rootState: RootState
) {
  let profile = rootState.questions.lastSearch;
  let user: ITravellyzeState['user'] = getters.currentUser;
  let options: Market[] = [];
  switch (profile.year) {
    case 2020:
      options = state.marketsOptions2020;
      break;
    case 2021:
      options = state.marketsOptions2021;
      break;
    default:
      options = state.marketsOptions2023;
      break;
  }

  options.forEach(function (option) {
    if (user.markets.length === 12 && !profile.multiple) {
      option.disable = !user.markets.includes(option.value);
    } else if (!user.markets.includes(option.value)) {
      option.disable = true;
    }
  });

  // TODO: Remove this when the user has access to the Nordic data
  const foundOption = options.find((option) => option.value === 44);
  if (foundOption && user.markets.some((e) => e <= 4)) {
    foundOption.disable = false;
  }

  return options;
}

export function destinationsPerWave(state: ITravellyzeState) {
  return (wave: Wave | Wave[]): Destination[] => {
    let destinations: Destination[] = [],
      minWave = wave,
      maxWave = wave;
    if (Array.isArray(wave)) {
      minWave = Math.min(...wave);
      maxWave = Math.max(...wave);
    }
    switch (minWave) {
      case Wave.Year2025B:
        destinations.push(...state.destinationsIDs2025B);
      case Wave.Year2025A:
        destinations.push(...state.destinationsIDs2025A);
      case Wave.Year2024B:
        destinations.push(...state.destinationsIDs2024B);
      case Wave.Year2024A:
        destinations.push(...state.destinationsIDs2024A);
      case Wave.Year2023B:
        destinations.push(...state.destinationsIDs2023B);
      case Wave.Year2023A:
        destinations.push(...state.destinationsIDs2023A);
      case Wave.Year2022B:
        destinations.push(...state.destinationsIDs2022B);
      case Wave.Year2022A:
        destinations.push(...state.destinationsIDs2022A);
      case Wave.Year2021:
        destinations.push(...state.destinationsIDs2021);

        break;
      default:
        /**
         * for 2020 and below, the countries have the previous nomenclature
         */
        destinations.push(...state.destinationsIDs2019);
    }
    switch (maxWave) {
      case Wave.Year2025B:
      case Wave.Year2025A:
      case Wave.Year2024B:
        destinations = destinations.filter(
          (destination) =>
            !state.destinationsIDsToRemove2024B
              .map((e) => e.value)
              .includes(destination.value)
        );
      case Wave.Year2023B:
        destinations = destinations.filter(
          (destination) =>
            !state.destinationsIDsToRemove2023B
              .map((e) => e.value)
              .includes(destination.value)
        );
      case Wave.Year2022B:
        destinations = destinations.filter(
          (destination) =>
            !state.destinationsIDsToRemove2022B
              .map((e) => e.value)
              .includes(destination.value)
        );
    }

    return destinations.sort((a, b) => a.label.localeCompare(b.label));
  };
}
